/**
 * Resolves the date filter for a slide-out section (Related Documents, Simple
 * Grid), tolerating both the new `dateFilter` shape and legacy docs that stored
 * `dateRange` (+ a top-level `dateField` on Related Documents).
 *
 * New/edited sections carry `dateFilter` directly. Legacy docs are mapped to the
 * equivalent 'Periods' filter so the rest of the app can treat every section
 * uniformly. This is a permanent read path — there is no migration.
 */
const getSlideoutDateFilter = (section: {
  // Optional here because older Firestore docs lack it, even though the section
  // types mark it required.
  dateFilter?: PerformanceBoardTypes.SlideOut.SlideOutDateFilter;
  dateRange?: PerformanceBoardTypes.SlideOut.SlideOutDateRange;
  dateField?: string;
}): PerformanceBoardTypes.SlideOut.SlideOutDateFilter => {
  if (section.dateFilter) {
    return section.dateFilter;
  }

  return {
    mode: 'Periods',
    interval: section.dateRange ?? {
      mode: 'Current Interval',
      isToDate: false,
    },
    dateField: section.dateField,
  };
};

export default getSlideoutDateFilter;
